import React, { useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import ReactDOM from "react-dom/client";
import { Routes, Route, useNavigate } from "react-router-dom";
import Subscription_Success from "./components/Subscription_Success/Subscription_Success";
import theme from "./components/styles/style";

import "./App.css";
import Header from "./components/Header/Header";
import Register from "./components/Register/Register";
import Login from "./components/Login/Login";
import Subscription_Type from "./components/Subscription_Type/Subscription_Type";
import Footer from "./components/Footer/Footer";
import Checkout_Dishes from "./components/Checkout_Dishes/Checkout_Dishes";
import Navbar from "./components/Header/Navbar";
import Landingpage1 from "./components/LandingPage1/Landingpage2";
import Select_Dishes from "./components/SelectDishes1/SelectDishes1";
import AllMenuHeader from "./components/Header/AllMenuHeader/AllMenuHeader";
import AllMenu from "./components/AllMenu/AllMenu";
import ExampleCmp from "./components/ExampleCmp";
import AllCuisine from "./components/AllCuisine/AllCuisine";
import About from "./components/About Screen/About";
import BecomeDriver from "./components/BecomeDriver/BecomeDriver";
import TermsAndConditions from "./components/TermsAndConditions/TermsAndConditions";
import Filter from "./components/Filter/Filter";
import Filtered from "./components/Filtered/Filtered";
import AmericanCuisine from "./components/AmericanCuisine/AmericanCuisine";
import SelectDishes1 from "./components/SelectDishes1/SelectDishes1";
import MealPlan from "./components/MealPlan/MealPlan";
import Cateter from "./components/Become a Cateter/Cateter";
import SavedAddress from "./components/Saved Address/Saved_Address";
import MealPlan1 from "./Pages/MyActivity/MealPlan";
import GetHelp from "./components/GetHelp/index";
import DashboardMainSidebar from "./components/DashboardMainSidebar/DashboardMainSidebar";
import Blog from "./components/Blog/Blog";
import DetailContent from "./components/Detail_Content/DetailContent";
import DeliveryDriver from "./components/Delivery_Driver/DeliveryDriver";
import Checkout from "./components/Checkout/Checkout";
import MerchantRegistration from "./components/Merchant Registration/MerchantRegistration";
import ErrorBoundary from "Pages/ErrorBoundary";
import SearchResult from "./components/Search/SearchResult";
function App() {
  const navigate = useNavigate();

  const token = localStorage.getItem("token");
  useEffect(() => {
    if (token === "" && token === null) navigate("/login");
  }, []);
  // useEffect(() => {
  //   // const token = localStorage.getItem('yourTokenKey'); // Replace with your actual token key
  //   const isTokenExpired = checkTokenExpiration(token);

  //   if (isTokenExpired) {
  //     // Token has expired, redirect to the login page
  //     navigate.push('/login');
  //   }
  // }, [navigate]);
  // // Function to check token expiration
  // const checkTokenExpiration = (token) => {
  //   if (!token) {
  //     // Token not found, treat as expired
  //     return true;
  //   }

  //   // const expirationTime = getTokenExpirationTime(token);
  //   const currentTime = Math.floor(Date.now() / 1000);

  //   return currentTime > expirationTime;
  // };

  return (
    <ThemeProvider theme={theme}>
      <ErrorBoundary>
        <Routes>
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/subscriptiontype" element={<Subscription_Type />} />
          <Route path="/footer" element={<Footer />} />
          <Route path="/checkoutdishes" element={<Checkout_Dishes />} />
          <Route path="/selectdishes" element={<Select_Dishes />} />
          <Route path="/" element={<Landingpage1 />} />
          <Route
            path="/subscriptionsuccess"
            element={<Subscription_Success />}
          />
          <Route path="/navbar" element={<Navbar />} />
          <Route path="/navbar2" element={<AllMenuHeader />} />
          <Route path="/navbar3" element={<Header />} />
          <Route path="/allmenu" element={<AllMenu />} />
          <Route path="/allcuisine" element={<AllCuisine />} />
          <Route path="/about" element={<About />} />
          <Route path="/becomedriver" element={<BecomeDriver />} />
          <Route path="/Terms&Conditions" element={<TermsAndConditions />} />
          <Route path="/Filter" element={<Filter />} />
          <Route path="/Filtered" element={<Filtered />} />
          <Route path="/American_Cuisine" element={<AmericanCuisine />} />
          <Route path="/SelectDish" element={<SelectDishes1 />} />
          <Route path="/SearchResult" element={<SearchResult />} />
          {/* <Route path="/Meal_Plan" element={<MealPlan />} /> */}
          <Route path="/Meal_Plan/:id" element={<MealPlan />} />
          <Route path="/becomecaterer" element={<Cateter />} />
          <Route path="/dashboard" element={<SavedAddress />} />
          <Route path="/MealPlan/:id" element={<MealPlan1 />} />
          <Route path="/GetHelp" element={<GetHelp />} />
          <Route path="/SideBar" element={<DashboardMainSidebar />} />
          <Route path="/Blog" element={<Blog />} />
          <Route path="/DetailContent" element={<DetailContent />} />
          <Route path="/registerdriver" element={<DeliveryDriver />} />
          <Route path="/Checkout_Dishes" element={<Checkout_Dishes />} />
          <Route path="/Checkout" element={<Checkout />} />
          <Route
            path="/merchantregistration"
            element={<MerchantRegistration />}
          />
        </Routes>
      </ErrorBoundary>
    </ThemeProvider>
  );
}

export default App;
